// extracted by mini-css-extract-plugin
module.exports = {"Footer":"footer-module--Footer--Jh0Yv"};